import React, { useState } from 'react';

import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import RadioField from 'components/application/RadioField';

import {
  trainingReportTypeGroups,
  trainingReportTypes,
} from 'components/trainingRegisterReports/helpers';
import CompletedTrainingReport from 'components/trainingRegisterReports/reports/CompletedTrainingReport';
import CurrentTrainingStatusReport from 'components/trainingRegisterReports/reports/CurrentTrainingStatusReport';
import ExpiringTrainingReport from 'components/trainingRegisterReports/reports/ExpiringTrainingReport';
import TrainingMatrixReport from 'components/trainingRegisterReports/reports/TrainingMatrixReport';

import { asyncScrollToTop } from 'components/helpers/scrolling';

const trainingReportComponents = {
  completedTraining: <CompletedTrainingReport />,
  currentTrainingStatus: <CurrentTrainingStatusReport />,
  expiringTraining: <ExpiringTrainingReport />,
  trainingMatrix: <TrainingMatrixReport />,
};

export default function TrainingRegisterReportsTab() {
  const searchParams = new URLSearchParams(window.location.search);

  const searchParamsType =
    trainingReportTypes.includes(searchParams.get('type')) ?
      searchParams.get('type')
    : null;

  const [selectedReport, setSelectedReport] = useState(
    searchParamsType || 'expiringTraining',
  );

  const { t: i18nTCommonShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const { t: i18nTComponentsShared } = useTranslation('components', {
    keyPrefix: 'trainingRegisterReports.shared',
  });

  const handleReportChange = (name) => {
    asyncScrollToTop().then(() => setSelectedReport(name));
  };

  return (
    <>
      <div className='col-sm-3 tw-pl-0'>
        <div className='tw-rounded-md tw-border-1 tw-border-solid tw-border-grey-100 tw-bg-white tw-p-6'>
          <h2 className='tw-m-0 tw-mb-6 tw-text-l tw-font-semibold tw-tracking-auto'>
            {i18nTCommonShared('reports')}
          </h2>
          <div className='tw-flex tw-flex-col tw-gap-5'>
            {[...trainingReportTypeGroups.entries()].map(
              ([groupName, group], groupIndex) => (
                <React.Fragment key={groupName}>
                  {groupIndex > 0 && (
                    <hr className='tw-m-0 tw-w-full tw-text-grey-100' />
                  )}
                  {group.map((trainingReportType) => (
                    <RadioField
                      checked={selectedReport === trainingReportType}
                      className='tw-m-0'
                      key={trainingReportType}
                      label={i18nTComponentsShared(
                        `reports.${trainingReportType}.label`,
                      )}
                      name={trainingReportType}
                      onChange={() => handleReportChange(trainingReportType)}
                      value={true}
                    />
                  ))}
                </React.Fragment>
              ),
            )}
          </div>
        </div>
      </div>
      <div className='col-sm-9 tw-mb-20 tw-pr-0'>
        {trainingReportComponents[selectedReport]}
      </div>
    </>
  );
}
